const rate = {
  path: 'rate',
  component: resolve => require(['../../../../../../../pages/admin/merchant/signing/yftAlipay/rate'], resolve),
  meta: {isRate: true}
}

export default rate
